import CalendarBookingTooltip from './CalendarBookingTooltip';

export default CalendarBookingTooltip;
